import React from 'react';
import DynamicLayout from '../components/DynamicLayout';
import { 
  Star, 
  BookOpen, 
  Users, 
  Zap
} from 'lucide-react';

const AboutPage = () => {
  return (
    <DynamicLayout>
      <div className="about-page">
        <div className="section" style={{ background: 'linear-gradient(135deg, #6b2937 0%, #8a3543 50%, #5a1f2a 100%)', padding: '4rem 0' }}>
          <div className="container">
            <div className="has-text-centered mb-6">
              <h1 className="title is-1 has-text-primary has-text-weight-bold mb-4">
                About The Academy
              </h1>
              <p className="subtitle is-4" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                Discover the ancient wisdom that has guided humanity for millennia
              </p>
            </div>
            
            <div className="columns is-multiline">
              <div className="column is-6">
                <div className="box" style={{
                  background: 'rgba(119, 44, 56, 0.3)',
                  border: '1px solid rgba(255, 215, 0, 0.3)',
                  borderRadius: '16px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                  padding: '2.5rem',
                  height: '100%',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
                }}>
                  <div className="has-text-centered mb-4">
                    <div style={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #FFC107 0%, #FF8C00 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 1.5rem'
                    }}>
                      <Star size={40} color="white" />
                    </div>
                  </div>
                  <h2 className="title is-3 has-text-primary has-text-centered mb-4">Our Mission</h2>
                  <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '1.1rem' }}>
                    We are dedicated to preserving and sharing the ancient esoteric traditions 
                    that have guided humanity's spiritual journey throughout history. Our academy 
                    serves as a bridge between the wisdom of the past and the seekers of today.
                  </p>
                </div>
              </div>
              
              <div className="column is-6">
                <div className="box" style={{
                  background: 'rgba(119, 44, 56, 0.3)',
                  border: '1px solid rgba(255, 215, 0, 0.3)',
                  borderRadius: '16px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                  padding: '2.5rem',
                  height: '100%',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
                }}>
                  <div className="has-text-centered mb-4">
                    <div style={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #FFC107 0%, #FF8C00 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 1.5rem'
                    }}>
                      <BookOpen size={40} color="white" />
                    </div>
                  </div>
                  <h2 className="title is-3 has-text-primary has-text-centered mb-4">What We Offer</h2>
                  <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '1.1rem' }}>
                    The curriculum covers astrology, tarot, numerology, runes, 
                    and Kabbalah - the foundational systems of mystical knowledge. Each course 
                    has different levels, designed to take you from complete beginner, up to expert level.
                  </p>
                </div>
              </div>
              
              <div className="column is-6">
                <div className="box" style={{
                  background: 'rgba(119, 44, 56, 0.3)',
                  border: '1px solid rgba(255, 215, 0, 0.3)',
                  borderRadius: '16px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                  padding: '2.5rem',
                  height: '100%',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
                }}>
                  <div className="has-text-centered mb-4">
                    <div style={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #FFC107 0%, #FF8C00 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 1.5rem'
                    }}>
                      <Users size={40} color="white" />
                    </div>
                  </div>
                  <h2 className="title is-3 has-text-primary has-text-centered mb-4">Our Community</h2>
                  <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '1.1rem' }}>
                    Join a vibrant community of seekers, practitioners, and scholars who share 
                    your passion for mystical knowledge. Connect with like-minded individuals 
                    and learn from experienced mentors.
                  </p>
                </div>
              </div>
              
              <div className="column is-6">
                <div className="box" style={{
                  background: 'rgba(119, 44, 56, 0.3)',
                  border: '1px solid rgba(255, 215, 0, 0.3)',
                  borderRadius: '16px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                  padding: '2.5rem',
                  height: '100%',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 16px 48px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.1)';
                }}>
                  <div className="has-text-centered mb-4">
                    <div style={{
                      width: '80px',
                      height: '80px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #FFC107 0%, #FF8C00 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 1.5rem'
                    }}>
                      <Zap size={40} color="white" />
                    </div>
                  </div>
                  <h2 className="title is-3 has-text-primary has-text-centered mb-4">Our Approach</h2>
                  <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.8', fontSize: '1.1rem' }}>
                    We believe in making ancient wisdom accessible to modern seekers. Our 
                    teachings combine traditional knowledge with contemporary understanding, 
                    creating a learning experience that is both authentic and relevant.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DynamicLayout>
  );
};

export default AboutPage;
